import { LocationStrategy } from '@angular/common';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'parcerias/abertura-conta/proponentes/dados-pessoais',
    pathMatch: 'full' as const
  },
  {
    path: '',
    loadChildren: () => import('./abertura-conta/abertura-conta.routes').then(r => r.routes)
  }
];

export const appRoutingProviders = [
  provideRouter(routes, 
    withEnabledBlockingInitialNavigation(),
    withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'top',
    })
  ),
  {
    provide: LocationStrategy,
    useClass: environment.locationStrategy,
  }
];

